import { render, staticRenderFns } from "./speechArtEdit.vue?vue&type=template&id=58dd2c96&"
import script from "./speechArtEdit.vue?vue&type=script&lang=js&"
export * from "./speechArtEdit.vue?vue&type=script&lang=js&"
import style0 from "./speechArtEdit.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports